import * as React from "react";
import { Gallery, GalleryImage } from "../Gallery/Gallery";
import { Attribute, Attributes } from "./Attributes";

interface FeatureInfoProps {
    attributes?: Attribute[];
    images?: GalleryImage[];
}

export const FeatureInfo = (props: FeatureInfoProps): JSX.Element => {
    return (
        <>
            {props.images?.length ? <Gallery images={props.images} /> : null}
            {props.attributes?.length ? <Attributes attributes={props.attributes} /> : null}
        </>
    );
};
